import React from 'react';
import { ArrowDown, Sparkles } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/canvaTranslations';

const HeroSection = () => {
  const { language } = useLanguage();
  const t = translations[language];
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #00C4CC 0%, #6C47FF 100%)',
      }}
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Decorative Icon */}
        <div className="mb-8 flex justify-center">
          <div className="p-4 bg-white/20 backdrop-blur-sm rounded-2xl shadow-xl">
            <Sparkles className="w-12 h-12 text-white" />
          </div>
        </div>

        {/* Main Title */}
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in-up">
          {t.hero.title}
          <br />
          <span className="text-4xl md:text-6xl font-light">{t.hero.subtitle}</span>
        </h1>

        {/* Personal Introduction */}
        <div className="mb-6 max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-semibold text-white mb-3">
            {t.hero.name}
          </h2>
        </div>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          {t.hero.description}
          <br />
          {t.hero.description2}
        </p>

        {/* Scroll Indicator */}
        <div className="animate-bounce">
          <ArrowDown className="w-8 h-8 text-white/80 mx-auto" />
        </div>
      </div>

      {/* Gradient Overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/10"></div>
    </section>
  );
};

export default HeroSection;


